import React from "react";
import DataTable from "components/common/DataTable/DataTable";
import useAvailableFeaturesManagement from "hooks/tenant/useAvailableFeaturesManagement";
import FeaturesListManagementTableColumns from "constants/tables/featuresListTableCoulumns";

const FeaturesManagementScreen = () => {
  const { availableFeatures } = useAvailableFeaturesManagement({
    fetchOnLoad: false,
  });

  return (
    <div className="row">
      <div className="col-12 d-flex flex-row align-items-center justify-content-between mb-4">
        <h4 className="mb-0 me-3">Manage Features</h4>
      </div>

      <div className="col-12 mx-auto mb-5">
        <div className="card shadow-lg">
          <DataTable
            tableData={availableFeatures}
            tableColumns={FeaturesListManagementTableColumns({
              handleCheckboxAction: () => null,
              onEditConfig: () => null,
            })}
            tableClassName="table-striped mb-0"
            classContainer="table-responsive"
            hiddenColumns={["active", "config", "adminConfig"]}
          />
        </div>
      </div>
    </div>
  );
};

export default FeaturesManagementScreen;
